import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button, Icon } from '@sm/wds-react';
import classNames from 'classnames';
import { SMHeaderContext } from '../SMHeaderContext';
import MobileMenuAuthed from './MobileMenuAuthed';
import MobileMenuAnon from './MobileMenuAnon';

import './mobile-menu.scss';

export class MobileMenu extends Component {
  static contextType = SMHeaderContext;

  toggleDrawer = () => {
    this.props.parentToggleDrawer();
  };

  render() {
    const { isDrawerOpen, mobileMenuColor } = this.props;

    const { isUserAuthenticated, lang, isEUDC, user } = this.context;

    const buttonClass = classNames(
      'sm-mobile-menu__trigger',
      `sm-mobile-menu__cta`,
      `sm-mobile-menu--${mobileMenuColor}`,
      `wds-float--left`
    );

    return (
      <>
        <Button
          variant="text"
          size="sm"
          className={buttonClass}
          onClick={this.toggleDrawer}
        >
          <Icon>{isDrawerOpen ? 'å' : 'm'}</Icon>
        </Button>
        <Sheet
          show={isDrawerOpen}
          onClose={this.toggleDrawer}
          placement="left"
          offsetTop={50}
        >
          <Choose>
            <When condition={isUserAuthenticated}>
              <MobileMenuAuthed lang={lang} user={user} isEUDC={isEUDC} />
            </When>
            <Otherwise>
              <MobileMenuAnon lang={lang} isEUDC={isEUDC} />
            </Otherwise>
          </Choose>
        </Sheet>
      </>
    );
  }
}

MobileMenu.propTypes = {
  isDrawerOpen: PropTypes.bool,
  mobileMenuColor: PropTypes.oneOf(['alt', 'secondary']),
  parentToggleDrawer: PropTypes.func.isRequired
};

MobileMenu.defaultProps = {
  isDrawerOpen: false,
  mobileMenuColor: 'alt'
};

export default MobileMenu;
